import { createContext } from "react"

export const initialState = {
    selectedNetworkYearlyStatus: null,
}

const initialDispatch = {}

export const RiskZonesStateContext = createContext(initialState)
export const RiskZonesDispatchContext = createContext(initialDispatch)